function getCartNote(){
  return document.getElementById("CartDrawer-Product-Note");
}

function clearCartNote(){
  sessionStorage.setItem("forGift", "");
  if(getCartNote()){
    getCartNote().value = "";
    getCartNote().innerText = "";
  }
  
}

function showTextarea(radio) {
  if (radio.value === "sim") {
    document.getElementById("areaTexto").classList.add("gift_content_open");
    sessionStorage.setItem("forGift", "Para presente")
  }
}

function hideTextarea(radio) {
  if (radio.value === "nao") {
    document.getElementById("areaTexto").classList.remove("gift_content_open");
   getCartNote().value = "";
   getCartNote().innerText = "";
    sessionStorage.setItem("forGift", "");
  }
}

function addNoteForGift() {
  // Obtenha a referência ao seu <textarea>
  if(getCartNote()){
    const textarea = getCartNote();
  if(!textarea.value.trim()){
     const forGift = sessionStorage.getItem("forGift");
    textarea.value = forGift;  
  }
  // Crie um evento 'input'
  const eventInput = new Event("input", { bubbles: true });

  // Dispare manualmente o evento 'input' no <textarea>
  textarea.dispatchEvent(eventInput);
  }
  
}

clearCartNote();
addNoteForGift();

